import { composeThemeFromProps, Compose } from '@css-modules-theme/react';
import clsx from 'clsx';
import 'react';
import { AlertTriangle, AlertOctagon, CheckSquare } from 'react-feather';
import defaultStyles from './styles/InlineMessage.module.scss.js';
import { jsx, jsxs } from 'react/jsx-runtime';
import { Typography } from '../typography/Typography.js';

const InlineMessage = ({
  type = 'custom',
  message = '',
  theme,
  showIcon,
  warningIcon,
  errorIcon,
  successIcon
}) => {
  const styles = composeThemeFromProps(defaultStyles, {
    theme
  }, {
    compose: Compose.Merge
  });
  const iconComponent = type === 'warning' && (warningIcon || /*#__PURE__*/jsx(AlertTriangle, {})) || type === 'error' && (errorIcon || /*#__PURE__*/jsx(AlertOctagon, {})) || type === 'success' && (successIcon || /*#__PURE__*/jsx(CheckSquare, {}));
  return /*#__PURE__*/jsx("div", {
    className: styles.root,
    children: /*#__PURE__*/jsxs(Typography, {
      variant: "caption",
      tag: "span",
      theme: {
        root: clsx({
          [styles.warning]: type === 'warning',
          [styles.error]: type === 'error',
          [styles.success]: type === 'success'
        })
      },
      children: [showIcon && iconComponent, message]
    })
  });
};

export { InlineMessage };
